<template>
  <div data-v-05fc7fa1="" data-v-e5781868="" class="topBar homeTopBar false">
    <div data-v-05fc7fa1="" class="content">
      <div data-v-5a0919b8="" data-v-05fc7fa1="" class="header topBarWithLeftBarHeader specialHeader">
        <span data-v-5a0919b8="" class="topImg"></span>
        <div data-v-5a0919b8="" class="topNav">
          <div data-v-5a0919b8="" class="notifications">
            <div data-v-5a0919b8="" class="bell">
              <svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconBell">
                <use data-v-338e1447="" xlink:href="#icon-iconBell"></use>
              </svg>
              <span data-v-5a0919b8="" v-if="$store.state.messageNum" class="num">{{ $store.state.messageNum }}</span>
              <div data-v-5a0919b8="" class="subnav msg-subnav">
                <div data-v-5a0919b8="" class="messages havemsg">
                  <div data-v-5a0919b8="" class="msg-list">
                    <ul data-v-5a0919b8="">
                      <li data-v-5a0919b8="" v-for="(item, index) in noticeList" :key="index">
                        <div data-v-5a0919b8="" class="title"><i data-v-5a0919b8=""></i>{{ item.title }}</div>
                        <p data-v-5a0919b8="" class="content" v-html="item.content"></p>
                        <div data-v-5a0919b8="" class="bottom">
                          <span data-v-5a0919b8="">{{ item.created_at }}</span>
                        </div>
                      </li>
                      <li data-v-5a0919b8="">
                        <div data-v-5a0919b8="" class="more-button" @click="$parent.goNav('/messages')">更多消息</div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--未登录-->
          <div data-v-5a0919b8="" class="notLogin" v-if="!$store.state.token">
            <div data-v-5a0919b8="" class="demo">还不是会员？ <a data-v-5a0919b8="" @click="registerBox()">注册会员</a></div>
            <div data-v-5a0919b8="" class="userLogin">
              <a data-v-5a0919b8="" class="btn buttonBordered" @click="loginBox()"
                >登录
                <svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconArrow">
                  <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></a
              ><a data-v-5a0919b8="" class="btn buttonSolid animation" @click="registerBox()"
                >注册
                <svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconArrow">
                  <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
              ></a>
            </div>
          </div>

          <!--已登录-->
          <div data-v-5a0919b8="" class="loggined" v-if="$store.state.token">
            <div data-v-5a0919b8="" class="userButtons">
              <a data-v-5a0919b8="" class="btn buttonSolid" href="javascript:void(0);" @click="$parent.goNav('/deposit')"
                ><svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconDeposit icon">
                  <use data-v-338e1447="" xlink:href="#icon-iconDeposit"></use>
                </svg>
                存款
                <svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconArrow">
                  <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></a
              ><a data-v-5a0919b8="" class="btn buttonBordered" href="javascript:void(0);" @click="$parent.goNav('/withdraw')"
                ><svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconWithdraw icon">
                  <use data-v-338e1447="" xlink:href="#icon-iconWithdraw"></use>
                </svg>
                取款
                <svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconArrow">
                  <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
              ></a>
              <a data-v-5a0919b8="" style="border: none; min-width: 82px" class="btn buttonBordered" href="javascript:void(0);" @click="transall"
                ><svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconDeposit icon">
                  <use data-v-338e1447="" xlink:href="#icon-iconDeposit"></use>
                </svg>
                一键回收
                <svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconArrow">
                  <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
              ></a>
            </div>
            <div data-v-5a0919b8="" class="user" v-if="$store.state.userInfo.username">
              <div data-v-5a0919b8="" class="info">
                <div data-v-5a0919b8="" class="info__top">
                  <h4 data-v-5a0919b8="" class="user-name">{{ $store.state.userInfo.username ? $store.state.userInfo.username : '' }} <img style="height: 15px" @click="$parent.goNav('/vip')" :src="baseURL + $store.state.userInfo.vipname" alt="" /></h4>
                </div>
                <p data-v-5a0919b8="" class="balance">{{ $store.state.userInfo.balance }}<span data-v-5a0919b8="">元</span></p>
              </div>
              <div data-v-5a0919b8="" class="userImg">
                <img data-v-5a0919b8="" @click="openuser" style="border-radius: 50%" :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/user.f11fb639.png'" />
                <div data-v-5a0919b8="" class="userNav">
                  <svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconArrowTop">
                    <use data-v-338e1447="" xlink:href="#icon-iconArrowTop"></use></svg
                  ><a data-v-5a0919b8="" :class="$route.path == '/accountSetting' ? 'active' : ''" href="javascript:void(0);" @click="$parent.goNav('/accountSetting')"
                    ><svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconSetting icon">
                      <use data-v-338e1447="" xlink:href="#icon-iconSetting"></use>
                    </svg>
                    账户设置 </a
                  ><a data-v-5a0919b8="" :class="$route.path == '/myWallet' ? 'active' : ''" href="javascript:void(0);" @click="$parent.goNav('/myWallet')"
                    ><svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconWallet icon">
                      <use data-v-338e1447="" xlink:href="#icon-iconWallet"></use>
                    </svg>
                    我的钱包 </a
                  ><a data-v-5a0919b8="" :class="$route.path == '/fundingRecords' ? 'active' : ''" href="javascript:void(0);" @click="$parent.goNav('/fundingRecords')"
                    ><svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconRecord icon">
                      <use data-v-338e1447="" xlink:href="#icon-iconRecord"></use>
                    </svg>
                    资金记录 </a
                  ><a data-v-5a0919b8="" class="row" @click="openT"
                    ><svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconNewLogout icon">
                      <use data-v-338e1447="" xlink:href="#icon-iconNewLogout"></use></svg
                    >安全退出
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  data() {
    return { noticeList: [], baseURL: '' };
  },
  created() {
    let that = this;
    that.getDatalist(); //获取消息
    that.baseURL = sessionStorage.getItem('baseURL') || '';
  },
  methods: {
    transall() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.$parent.showTost(1, res.message);
          that.refreshusermoney();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.$parent.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
        that.$parent.hideLoading();
      });
    },
    getDatalist() {
      let that = this;
      let page = that.page;
      that.$apiFun
        .post('/api/noticeList', { page })
        .then(res => {
          if (res.code == 200) {
            that.noticeList = res.data.data;
            localStorage.setItem('messageNum', res.data.data.length);
            that.$store.commit('changMessageNum');
          }
        })
        .catch(res => {});
    },

    openT() {
      $('.outLoginBox').fadeIn(300);
    },
    //弹出登录框
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    //弹出注册框
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    //弹出忘记密码框
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
    openuser() {
      //鼠标经过头像显示下拉菜单
      $('.user').find('.userImg .userNav').toggleClass('userNav--active');
    },
  },
  mounted() {
    $('.mask .close').click(function () {
      $(this).parents('.mask').fadeOut(300);
    });
    $('.user').hover(
      function () {
        $(this).find('.userImg .userNav').addClass('userNav--active');
      },
      function () {
        $(this).find('.userImg .userNav').removeClass('userNav--active');
      },
    );
  },
  updated() {
    let that = this;
    if (that.noticeList.length == 0) {
      that.getDatalist(); //获取消息
    }
    //     //鼠标经过头像显示下拉菜单
    // $('.user').hover(function () {
    //   $(this).find('.userImg .userNav').toggleClass('userNav--active');
    // });

    $('.user').hover(
      function () {
        $(this).find('.userImg .userNav').addClass('userNav--active');
      },
      function () {
        $(this).find('.userImg .userNav').removeClass('userNav--active');
      },
    );
  },
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/chunk-b7675268.a1b3941c.css';
</style>



// WEBPACK FOOTER //
// src/components/libs/Header.vue